import React from "react";
import Image from "next/image";
import { QRCodeCanvas } from "qrcode.react";
import { IconCloseBlue } from "@/components/Icons";
import { getTenjinTrackUrlWithAttribution } from "@/utils/tenjin";
import { YOO_FINDS_LOGO } from "@/cdn";
import "./index.scss";

const classPrefix = "yfm-exclusive-earning-mask";

interface ExclusiveEarningMaskProps {
  onClose: () => void;
}

const ExclusiveEarningMask: React.FC<ExclusiveEarningMaskProps> = ({
  onClose,
}) => {
  return (
    <div className={classPrefix}>
      <div className={`${classPrefix}__mask`} onClick={onClose}></div>
      <div className={`${classPrefix}__content`}>
        <div className={`${classPrefix}__close-icon`} onClick={onClose}>
          <IconCloseBlue />
        </div>
        <div className={`${classPrefix}__pc-content`}>
          <div className={`${classPrefix}__title`}>
            Try our mobile app for a better experience
          </div>
          <Image
            className={`${classPrefix}__logo`}
            src={YOO_FINDS_LOGO}
            alt="YooFinds Logo"
            width={100}
            height={20}
          />
          <div className={`${classPrefix}__qrcode-wrapper`}>
            <QRCodeCanvas
              value={getTenjinTrackUrlWithAttribution()}
              size={120}
            />
          </div>
          <div className={`${classPrefix}__decs-text`}>
            <p className={`${classPrefix}__bolder`}>
              Exclusive Earning Tools for TikTok Creators
            </p>
            <p className={`${classPrefix}__bolder`}>
              1. Higher Product Commissions
            </p>
            <p className={`${classPrefix}__indent-2`}>
              Earn 5%–20% more than public commission rates.
            </p>
            <p className={`${classPrefix}__bolder`}>
              2. Sponsored Ad Opportunities
            </p>
            <p className={`${classPrefix}__indent-2`}>
              Get paid to participate in brand campaigns and promotional tasks.
            </p>
            <p className={`${classPrefix}__bolder`}>3. Free Product Samples</p>
            <p className={`${classPrefix}__indent-2`}>
              Receive free samples for content creation and early access
              reviews.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExclusiveEarningMask;
